<template>
    <!-- 统一空状态：列表无数据时展示，避免大片留白显得"坏掉了" -->
    <div class="empty">
        <div class="empty-orb">
            <span class="empty-icon">{{ icon }}</span>
        </div>
        <div class="empty-title">{{ title }}</div>
        <div v-if="desc" class="empty-desc muted2">{{ desc }}</div>
        <slot />
    </div>
</template>

<script setup>
defineProps({
    icon: { type: String, default: "✦" },
    title: { type: String, default: "暂无数据" },
    desc: { type: String, default: "" },
});
</script>

<style scoped>
.empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 48px 20px;
    text-align: center;
}

.empty-orb {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    background: radial-gradient(circle at 35% 30%, rgba(0, 229, 255, .3), rgba(124, 92, 255, .15));
    border: 1px solid var(--stroke);
    box-shadow: var(--glow-cyan);
    animation: bob 3.2s ease-in-out infinite;
}

.empty-icon {
    font-size: 28px;
    color: #cfe9ff;
}

.empty-title {
    font-size: 15px;
    font-weight: 700;
}

.empty-desc {
    font-size: 13px;
    max-width: 320px;
}

@keyframes bob {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-8px);
    }
}
</style>
